import { fork, takeLatest, takeEvery, put, call } from "redux-saga/effects";
import { delay } from "redux-saga";
import CompanyLosService from "../services/company-los-services";
import {
    fetchedInvoiceJob,
    failedFetchInvoiceJob,
    fetchedCreateInvoiceJob,
    failedFetchCreateInvoiceJob,
    fetchedUpdateInvoiceJob,
    failedFetchUpdateInvoiceJob,
    fetchedAllInvoiceJob,
    failedFetchAllInvoiceJob,
    fetchedInvoiceCards,
    failedFetchInvoiceCards,
    fetchedMarkJobPending,
    failedFetchMarkJobPending,
    fetchedFinalSubmission,
    failedFinalSubmission,
    fetchFinalSubmission,
    fetchedRemoveInvoice,
    failedRemoveInvoice,
    updateInvoiceJobStatus,
    fetchedDealerFromGstin,
    failedFetchDealerFromGstin
} from "../actions";
import { COMPANY_LOS_ACTIONS } from "../constants";
import moment from "moment";
import { message } from "antd";


function* fetchInvoiceByJob({ payload }) {
    try {
        const { data, error } = yield call(CompanyLosService.getJobById, payload.jobId);
        if (!error) {
            yield put(fetchedInvoiceJob(payload.jobId, data));
        } else {
            yield put(failedFetchInvoiceJob(payload.jobId, error));
        }
    } catch (error) {
        yield put(failedFetchInvoiceJob(payload.jobId, error));
    }
}

function* fetchCreateInvoiceJob({ payload }) {
    try {
        let formData = new FormData();
        payload.invoiceFiles.map(_ => formData.append("invoice_files", _));
        formData.append("seller_gstin", payload.seller.gstin);
        const { data, error } = yield call(CompanyLosService.createInvoiceJob, formData);
        if (!error) {
            yield put(fetchedCreateInvoiceJob(payload.requestId, data));
            yield* jobStatusTimer(payload.requestId, data.id);
        } else {
            yield put(failedFetchCreateInvoiceJob(payload.requestId, error));
        }
    } catch (error) {
        yield put(failedFetchCreateInvoiceJob(payload.requestId, error));
    }
}


// function* jobStatusTimer(requestId, jobId) {
//     let isParsingInvoices = true;
//     while(isParsingInvoices) {
//         const { data, error } = yield call(CompanyLosService.getJobById, jobId);
//         if(!error) {
//             isParsingInvoices = data.map(_ => _.parse_status === 1).reduce((agg, _) => agg & _, true);            
//             yield put(updateInvoiceJobStatus(
//                 requestId, 
//                 jobId,
//                 data.map(_ => {
//                     if(_.invoice_date && moment(_.invoice_date, "YYYY-MM-DD").isValid()) {
//                         _.invoice_date = moment(_.invoice_date, "YYYY-MM-DD");
//                     }
//                     return _;
//                 }),
//                 data.map(_ => [2, 3].includes(_.parse_status)).length,
//             ));
//             yield delay(5000);
//         }
//     }
// }

function* jobStatusTimer(requestId, jobId) {
    let isParsingInvoices = true;
    let counter = 0;
    while (isParsingInvoices) {
        const { data, error } = yield call(CompanyLosService.getJobById, jobId);
        if (!error) {
            isParsingInvoices = data.some(_ => _.parse_status === 1);
            // isParsingInvoices = data.map(_ => _.parse_status).reduce((agg, _) => agg && _, true);
            yield put(updateInvoiceJobStatus(
                requestId,
                jobId,
                data.map(_ => {
                    if (_.invoice_date && moment(_.invoice_date, "YYYY-MM-DD").isValid()) {
                        _.invoice_date = moment(_.invoice_date, "YYYY-MM-DD");
                    }
                    return _;
                }),
                data.filter(_ => [2, 3].includes(_.parse_status)).length,
            ));
            yield delay(5000);
            if (counter > 5) {
                isParsingInvoices = false;
                yield put(updateInvoiceJobStatus(
                    requestId,
                    jobId,
                    data,
                    data.length,
                ));
            }
        }
        counter++;
    }
}

function* fetchUpdateInvoiceJob({ payload }) {
    try {
        const { error } = yield call(
            CompanyLosService.updateInvoiceJob,
            payload.jobId,
            payload.invoices.map(_ => ({
                ..._,
                invoice_date: _.invoice_date.format("YYYY-MM-DD")
            })),
            payload.type
        );
        if (!error) {
            if (payload.type === "maker") {
                yield put(fetchFinalSubmission(payload.jobId, "maker"));
            }
            if (payload.isFinalSubmission) {
                yield put(fetchFinalSubmission(payload.jobId, "checker"));
            }
            yield put(fetchedUpdateInvoiceJob(payload.jobId));
        } else {
            yield put(failedFetchUpdateInvoiceJob(error));
        }
    } catch (error) {
        yield put(failedFetchUpdateInvoiceJob(error));
    }
}

function* fetchAllInvoiceJob({ payload }) {
    try {
        const isEmail = payload.email === "yes";
        const { data, error } = yield call(CompanyLosService.getAllInvoiceJob, payload.search, payload.status, payload.page, payload.start_date, payload.end_date, payload.email ? "yes" : "no");
        if (error) {
            yield put(failedFetchAllInvoiceJob(error));
            return;
        }
        if (isEmail) {
            message.success(data && data.message, "Report sent via email");
            yield put(fetchedAllInvoiceJob({}));
            return;
          }
        if (data && data.message) {
            message.error(data.message);
            yield put(fetchedAllInvoiceJob({ count: 0, results: []}, payload.page, data.message ));
        } else {
            yield put(fetchedAllInvoiceJob(data, payload.page));
        }
    } catch (error) {
        yield put(failedFetchAllInvoiceJob(error));
    }
}

function* fetchInvoiceCards({payload}) {
    try {
        const { data, error } = yield call(CompanyLosService.getInvoiceCards, payload.start_date, payload.end_date);
        if (!error) {
            yield put(fetchedInvoiceCards(data));
        } else {
            yield put(failedFetchInvoiceCards(error));
        }
    } catch (error) {
        yield put(failedFetchInvoiceCards(error));
    }
}

function* fetchMarkJobPending({ payload }) {
    try {
        const { data, error } = yield call(CompanyLosService.markJobPending, payload.jobId);
        if (!error) {
            yield put(fetchedMarkJobPending(data));
        } else {
            yield put(failedFetchMarkJobPending(error));
        }
    } catch (error) {
        yield put(failedFetchMarkJobPending(error));
    }
}

function* fetchFinalSubmissions({ payload }) {
    try {
        const { data, error } = yield call(CompanyLosService.finalSubmission, { job_id: payload.jobId, type: payload.type });
        if (!error) {
            yield put(fetchedFinalSubmission(payload.jobId, payload.type, data));
        } else {
            yield put(failedFinalSubmission(payload.jobId, payload.type, error));
        }
    } catch (error) {
        yield put(failedFinalSubmission(payload.jobId, payload.type, error));
    }
}

function* fetchRemoveInvoice({ payload }) {
    try {
        const { data, error } = yield call(CompanyLosService.removeInvoice, { job_id: payload.jobId, buffer_id: payload.invoiceId, status_reason: payload.rejectReason });
        if (!error) {
            if (payload.isFinal) {
                yield put(fetchFinalSubmission(payload.jobId, "checker"));
            }
            yield put(fetchedRemoveInvoice(payload.jobId, payload.remainingInvoices, data));
        } else {
            yield put(failedRemoveInvoice(payload.jobId, error));
        }
    } catch (error) {
        yield put(failedRemoveInvoice(error));
    }
}


function* fetchDealerFromGstin({ payload }) {
    try {
        const { data, error } = yield call(CompanyLosService.getDealers ,payload.gstin );
        if (!error) {
            yield put(fetchedDealerFromGstin(data));
        } else {
            yield put(failedFetchDealerFromGstin(error));
        }
    } catch (error) {
        message.info("Please try after some time!");
        yield put(failedFetchDealerFromGstin(error));
    }
}

export default fork(function* () {
    yield takeLatest(COMPANY_LOS_ACTIONS.FETCH_INVOICE_JOB, fetchInvoiceByJob);
    yield takeEvery(COMPANY_LOS_ACTIONS.FETCH_CREATE_INVOICE_JOB, fetchCreateInvoiceJob);
    yield takeLatest(COMPANY_LOS_ACTIONS.FETCH_UPDATE_INVOICE_JOB, fetchUpdateInvoiceJob);
    yield takeLatest(COMPANY_LOS_ACTIONS.FETCH_ALL_INVOICE_JOB, fetchAllInvoiceJob);
    yield takeLatest(COMPANY_LOS_ACTIONS.FETCH_INVOICE_CARDS, fetchInvoiceCards);
    yield takeLatest(COMPANY_LOS_ACTIONS.FETCH_MARK_JOB_PENDING, fetchMarkJobPending);
    yield takeLatest(COMPANY_LOS_ACTIONS.FETCH_FINAL_SUBMISSION, fetchFinalSubmissions);
    yield takeLatest(COMPANY_LOS_ACTIONS.FETCH_REMOVE_INVOICE, fetchRemoveInvoice);
    yield takeLatest(COMPANY_LOS_ACTIONS.FETCH_DEALERS_FROM_GSTIN, fetchDealerFromGstin);
});